import RedirectBackButton from "components/RedirectBackButton";
import SnackbarMessage from "components/SnackbarMessage";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { CertificateSkuRequest } from "services/KnowfullyAdminClient";
import { SnackbarMessageProps } from "types/common-types";
import translateError from "utils/translateError";
import CertificateAccordions from "./CertificateAccordions";

const CertificateCreateForm = () => {
  const {
    certificateService,
    certificateListUrl,
    certificateDetailsUrl,
  } = useGlobalContext();
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  useTitle(t({ id: "certificateFormCreateButton" }));

  const onSubmit = async (values: CertificateSkuRequest) => {
    try {
      var result = await registerPromise(
        certificateService.saveCertificate(values)
      );

      queryClient.invalidateQueries("certificates");

      setSnackbarMessage(
        new SnackbarMessageProps(t({ id: "certificateCreated" }))
      );

      navigate(certificateDetailsUrl(result.id));
      return result;
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <RedirectBackButton
        redirectRoute={certificateListUrl()}
        labelKey="backToListButtonLabel"
      />
      <h2>
        <T id="certificateFormCreateTitle" />
      </h2>
      <CertificateAccordions
        onSubmit={onSubmit}
        onCancel={() => {
          navigate(certificateListUrl());
        }}
        submitLabel={t({ id: "certificateFormCreateButton" })}
      />
      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
};

export default CertificateCreateForm;
